module.exports = __webpack_public_path__ + "29bfff9fc3027cbb5de37172cfa15f41.svg";